import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InstallerConfirmCopy } from '../../../utils/installer-confirm-copy.util';

export type AdminControlConfirmDialogData = Partial<InstallerConfirmCopy> & {
  /** Legacy create-user fallback fields */
  textHtml?: string;
  subtitle?: string;
  bullets?: string[];
};

@Component({
    selector: 'app-admin-control-confirm-dialog',
    templateUrl: './admin-control-confirm-dialog.component.html',
    styleUrls: ['./admin-control-confirm-dialog.component.css'],
    standalone: false
})
export class AdminControlConfirmDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<AdminControlConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AdminControlConfirmDialogData
    ) {
        this.data = data || {};
    }

    dontShowAgain = false;

    /** Fallback for create-user (no installerConfirmCopy data passed). */
    defaultBullets: string[] = [
        'They sign in and cannot pause tracking',
        'Your company settings are applied to them',
        'The icon stays visible on their computer',
        'You can change their settings later',
    ];

    get useConsentLayout(): boolean {
        return !!(this.data?.leadHtml || this.data?.impactHeading || this.data?.impactLines?.length);
    }

    get showDontShowCheckbox(): boolean {
        if (this.data?.showDontShow === false) {
            return false;
        }
        // Consent download flows always hide; create-user fallback keeps checkbox.
        return !this.useConsentLayout;
    }

    onCancel(): void {
        this.dialogRef.close({ confirmed: false, dontShowAgain: this.dontShowAgain });
    }

    onConfirm(): void {
        this.dialogRef.close({ confirmed: true, dontShowAgain: this.dontShowAgain });
    }
}
